var map = {
	"./index.js": 85,
	"./v1/advanced/advanced_albums_popup.coffee": 172,
	"./v1/advanced/advanced_category.coffee": 174,
	"./v1/advanced/advanced_image_gallery.coffee": 175,
	"./v1/advanced/advanced_publication_gallery.coffee": 176,
	"./v1/advanced/advanced_select_events.coffee": 177,
	"./v1/advanced/custom_cultura_agenda.coffee": 178,
	"./v1/advanced/custom_event_detail.coffee": 182,
	"./v1/advanced/custom_kings2020.coffee": 183,
	"./v1/advanced/posters_columns.coffee": 184,
	"./v1/advanced/posters_columns_popup.coffee": 185,
	"./v1/advanced/posters_slider_timeline.coffee": 186,
	"./v1/headers/header_one_picture_landing.coffee": 187,
	"./v1/panel/panel_vertical_slider.coffee": 188,
	"./v2/panel/banner_subtitle_two_columns.coffee": 189,
	"./v2/panel/banner_three_columns.coffee": 190,
	"./v2/panel/banner_two_columns.coffee": 191,
	"./v2/panel/panel_picture_text.coffee": 192,
	"./v2/panel/panel_vertical_slider.coffee": 193,
	"./v3/advanced/advanced_select_events.coffee": 194,
	"./v3/panel/panel_picture_text_publication.coffee": 195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;